import React from 'react';
import Modal from 'components/Modal';

const ExploreModal = ({ children, onClose, title }) => {
	return (
		<Modal
			isFullscreen={true}
			zIndex="10000000"
			onClose={() => onClose(false)}
			cancelLabel="Close"
			title={title ? title : 'Title'}
		>
			{children}
		</Modal>
	);
};

export default ExploreModal;
